<div class="product-modal">
    <div class="row">
        <div class="col-md-12 my-5">
            <h1 style="text-align: center;">{{product.name}}</h1>
            <iframe
                [src]="pdfUrl | safe: 'resourceUrl'"
                style="width:100%; height:500px;"
                frameborder="0"
            ></iframe>
        </div>
        <div class="col-md-12">
            <div
                *ngIf="!canBuyForChild; else BusinessAccountWithChildren"
                class="btn-toolbar pull-right"
            >
                <div>
                    <button
                        *ngIf="product.isPurchasable && product.listPrice === 0"
                        type="button"
                        class="btn btn-primary m-1"
                        (click)="downloadProductFile(product)"
                    >
                        <i class="fa fa-shopping-cart"></i>
                        Free Download
                    </button>
                    <button
                        *ngIf="product.isPurchasable && product.listPrice > 0"
                        type="button"
                        class="btn btn-primary m-1"
                        (click)="onAddItemToCart(product.id)"
                    >
                        <i class="fa fa-shopping-cart"></i>
                        Add to Cart
                    </button>
                </div>
                <button
                    (click)="onContinue()"
                    type="button"
                    class="btn btn-primary m-1"
                >
                    Continue shopping
                </button>
            </div>
            <ng-template #BusinessAccountWithChildren>
                <app-product-business-account
                    [childAccounts]="childAccounts"
                    (add)="onBatchAddItemToCart($event)"
                    (continue)="onContinue()"
                >
                </app-product-business-account>
            </ng-template>
        </div>
    </div>
</div>
